import { OPERATOR } from "../../shared/constants";

// No.10 ドメイン移管サポート・手順ガイド（静的ガイド）。
// エンジニア相談予約は廃止し、「お問い合わせから個別対応」に簡略化（要件）。

const REGISTRARS = [
  { name: "お名前.com", desc: "GMOインターネットグループが提供するドメインサービス" },
  { name: "ムームードメイン", desc: "GMOペパボが提供するドメイン取得・管理サービス" },
  { name: "エックスサーバー", desc: "レンタルサーバーとドメインの一体型サービス" },
  { name: "Google Workspace", desc: "Googleのサービスでドメインを管理している" },
  { name: "自分では分からない", desc: "管理会社が不明、または確認方法がわからない" },
];

const STEPS = [
  { no: "1", title: "移管準備", items: ["ドメインの有効期限確認", "移管ロックの解除", "Authコード取得（認証コード）"] },
  { no: "2", title: "移管申請", items: ["新しい管理先で申請", "Authコードの入力", "連絡先情報の確認"] },
  { no: "3", title: "承認手続き", items: ["現在の管理者に承認依頼", "承認メールの確認・対応", "移管の承認完了"] },
  { no: "4", title: "DNS設定確認", items: ["ネームサーバーの設定", "DNSレコードの確認", "反映状況の確認"] },
  { no: "5", title: "サイト・メール確認", items: ["SSL証明書の確認", "301リダイレクトの確認", "メール送受信の確認"] },
];

const CHECKS = [
  { title: "DNS設定の確認", items: ["ネームサーバーが正しく設定されている", "Aレコード / CNAMEの確認", "反映状況を確認（数時間〜48時間）"] },
  { title: "SSL証明書の確認", items: ["SSLが有効になっていること", "httpsでアクセスできること", "証明書の期限チェック"] },
  { title: "301リダイレクト設定", items: ["wwwあり / なしの統一", "httpからhttpsへのリダイレクト", "古いURLからの転送設定"] },
  { title: "メール設定の確認", items: ["MXレコードが正しいこと", "メールの送受信テスト", "SPF / DKIM / DMARCの確認"] },
];

export function DomainGuidePage() {
  return (
    <section className="wizard domain-guide">
      <div className="wizard-head">
        <span className="step-tag">No.10</span>
        <h1>ドメイン移管サポート・手順ガイド</h1>
        <p className="muted">
          現在のドメイン管理方法をご確認のうえ、以下の手順に沿って移管を進めてください。ご不明な場合はお問い合わせから個別にサポートします。
        </p>
      </div>

      <div className="card">
        <h2>01 現在のドメイン管理方法</h2>
        <p className="muted small">
          ご利用中の管理会社を確認してください。Whois情報（ドメインの所有者情報）や、更新・管理に関するメールの送信元から確認できます。
        </p>
        <div className="registrar-grid">
          {REGISTRARS.map((r) => (
            <div key={r.name} className="registrar-card">
              <strong>{r.name}</strong>
              <span className="muted small">{r.desc}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="card">
        <h2>02 ドメイン移管の基本ステップ</h2>
        <p className="muted small">
          一般的なドメイン移管の流れです。管理会社によって一部手順が異なる場合があります。
        </p>
        <div className="guide-steps">
          {STEPS.map((s) => (
            <div key={s.no} className="guide-step">
              <div className="guide-step-no">{s.no}</div>
              <strong>{s.title}</strong>
              <ul className="check-list small">
                {s.items.map((i) => (
                  <li key={i}>{i}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="card">
        <h2>03 移管後に必ず行うチェックリスト</h2>
        <p className="muted small">サイトとメールが正常に動作することを確認しましょう。</p>
        <div className="check-grid">
          {CHECKS.map((c) => (
            <div key={c.title} className="check-block">
              <strong>{c.title}</strong>
              <ul className="check-list small">
                {c.items.map((i) => (
                  <li key={i}>{i}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="card contact-band">
        <h2>不安な方は個別にサポートします</h2>
        <p className="muted">
          ドメイン移管に不安がある場合は、お問い合わせから個別にご相談ください。現在の設定確認から移管後の動作確認まで、{OPERATOR.companyName}が対応します。
        </p>
        <p className="muted small">
          ※専任エンジニアによる予約制サポートは行っておりません。ダッシュボードの「お問い合わせ」またはサポート窓口よりご連絡ください。
        </p>
      </div>
    </section>
  );
}
